import { AutogenModelPayrollControl, AutogenRowPayrollControl } from "./autogen/AutogenModelPayrollControl";

export class ModelPayrollControl extends AutogenModelPayrollControl<RowPayrollControl> {
    constructor() {
        super(RowPayrollControl);
    }
}

export class RowPayrollControl extends AutogenRowPayrollControl {
}